import { AbstractBlockFactory } from '../block/AbstractBlockFactory';
import {
    BlockType,
    ChartComponentSettings,
    ComponentSettingsChartMeasureField,
    NewBlockContextType,
} from '@report-content';
import { AssocArray, YNValues } from 'tools/types';

export class BlockFactoryRangeChart extends AbstractBlockFactory<ComponentSettingsRangeChart> {
    public getNewBlock({
        nextUId,
        nextSortOrder,
        datasetFields,
    }: NewBlockContextType): BlockType<ComponentSettingsRangeChart> {
        const uid = 'block_uid_' + nextUId;
        return {
            // TODO:
            component: {
                datasetRendererBlockComponentId: nextUId,
                datasetRendererBlockId: nextUId,
                datasetRendererComponentId: nextUId,
                displayOrder: nextSortOrder,
                internalName: 'range_chart',
                settings: {
                    uid: uid,
                    internal_name: 'range_chart',
                    dataQueries: {
                        table: {
                            resultFieldAggregations: {},
                            resultFields: [],
                            sort: [],
                        },
                    },
                    component_name: 'Range',
                    title: '',
                    height: 600,
                    show_in_viewer: 'Y',
                    include_in_email: 'Y',
                    // is_preview_ind: 'Y',
                    groupFilter: { operator: 'AND', rules: [] },
                    include_in_email_attachment: 'Y',
                    is_collapsed_ind: 'N',
                    //@ts-ignore
                    range_start: datasetFields[0],
                    //@ts-ignore
                    range_end: datasetFields[0],
                    //@ts-ignore
                    x_field: datasetFields[0],
                    display_value: 'Y',
                    report_no_units_label: 'No exceptions',
                    report_single_unit_label: 'exception',
                    report_multiple_units_label: 'exceptions',
                    isOnCreation: true,
                    value_axis_label: '',
                    drillTo: [],
                },
            },
            // datasetRendererBlockId: number;
            displayOrder: nextSortOrder,
            // elementId: number;
            uid: uid,
        };
    }
}

export interface ComponentSettingsRangeChart extends ChartComponentSettings {
    uid: string;
    component_name: 'Range';
    localPalette: AssocArray<string>;
    x_field: ComponentSettingsChartMeasureField;
    range_start: ComponentSettingsChartMeasureField;
    range_end: ComponentSettingsChartMeasureField;
    display_value: YNValues;
    report_no_units_label: 'No exceptions';
    report_single_unit_label: 'exception';
    report_multiple_units_label: 'exceptions';
    internal_name: 'range_chart';
    value_axis_label: '';
}
